// extracted by mini-css-extract-plugin
export default {"cta":"beam-cta_cta__vBzMc","icon":"beam-cta_icon__UUamv","row":"beam-cta_row__5MOHh","left":"beam-cta_left__kuJxm","right":"beam-cta_right__Ygkfb","button":"beam-cta_button__rgydl"};